module.exports = __webpack_public_path__ + "static/media/ipsum_city_old.eb60d9a9.png";